import Vue from 'vue'
import Vuex from 'vuex'
import modal from './modules/modal'
import terms from './modules/terms'
import login from './modules/login'
import menu from './modules/menu'
import bgm from './modules/bgm'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    modal,
    terms,
    login,
    menu,
    bgm,
  }
})
